import { render, staticRenderFns } from "./ShareGoodsList.vue?vue&type=template&id=26154924&scoped=true"
import script from "./ShareGoodsList.vue?vue&type=script&lang=ts"
export * from "./ShareGoodsList.vue?vue&type=script&lang=ts"
import style0 from "./ShareGoodsList.vue?vue&type=style&index=0&id=26154924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26154924",
  null
  
)

export default component.exports